import React from "react";
import { FaEdit, FaUserSlash } from "react-icons/fa";

const ClientTable = ({ clients, page, itemsPerPage, onEdit }) => {
  return (
    <div className="card">
      <table className="clients-table">
        <thead>
          <tr>
            <th style={{ width: "80px" }}>SI.NO</th>
            <th>Company Name</th>
            <th>Name</th>
            <th>Email</th>
            <th>Added Date</th>
            <th>Total Sales (£)</th>
            <th style={{ width: "100px", textAlign: "center" }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {clients && clients.length > 0 ? (
            clients.map((client, i) => (
              <tr key={client.id || i}>
                <td>{(page - 1) * itemsPerPage + i + 1}</td>
                <td className="company-name">{client.company}</td>
                <td>{client.name}</td>
                <td className="email">{client.email}</td>
                <td>{client.invited}</td>
                <td className="total-sales">{client.totalSales}</td>
                <td style={{ textAlign: "center" }}>
                  <button 
                    className="btn-icon" 
                    title="Edit Client"
                    onClick={() => onEdit(client)}
                  >
                    <FaEdit size={16} />
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={7}>
                <div className="empty-state" style={{ padding: "60px 0" }}>
                  <FaUserSlash size={48} style={{ color: "#d1d5db", marginBottom: "16px" }} />
                  <h3 style={{ margin: "0 0 8px 0", color: "#374151" }}>No clients found</h3>
                  <p style={{ margin: 0, color: "#6b7280" }}>Your client list is currently empty. Add a new client to get started.</p>
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ClientTable;
